// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1890ff"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10b90d92","scoped":false,"hasInlineConfig":false}!./~/sass-loader?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/index/App.vue
// module id = 806
// module chunks = 1